import { ReactComponent as CloseSvg } from '../../assets/icons/close.svg';

export const CloseIcon: SvgIcon = (props) => {
    return <CloseSvg {...props} />;
};
